<template>
  <div class="filter">
    <slot></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      childCount: 0
    }
  },
  mounted() {
    this.childCount = this.$el.childElementCount
  },
  computed: {
    headerClass() {
      return {
        'header-padding-large': this.childCount > 1,
        'header-margin-top': this.childCount > 2
      }
    }
  }
}
</script>
